module.exports = __webpack_public_path__ + "static/media/courge.751cb6d2.svg";